<template>
  <div>
    <h1 v-show="!showSuccessMessage" class="login__title mb-8">
      {{ $t('auth.recoverPassword') }}
    </h1>

    <div v-show="showSuccessMessage" class="text-center">
      <v-icon class="text-h1 green--text">mdi-email-fast-outline</v-icon>
      <h2 class="grey--text mt-8 mb-2">
        {{ $t('auth.success.recoverPasswordEmailSent') }}
      </h2>
      <p>
        {{ $t('auth.success.recoverPasswordEmailSentDescription') }}
      </p>

      <v-btn
        @click="$router.push('/login')"
        color="primary"
        class="px-2"
        depressed
        large
        text
      >
        <h5 class="d-flex">
          <v-icon left>mdi-chevron-left</v-icon>
          {{ $t('auth.goBackToLogin') }}
        </h5>
      </v-btn>
    </div>

    <v-form v-show="!showSuccessMessage" ref="form" @submit.prevent="validate" lazy-validation>
      <v-text-field
        v-model="username"
        :rules="[rules.email]"
        :label="$t('auth.email')"
        :disabled="isLoading"
        class="mb-5"
        autocomplete="off"
        hide-details="auto"
        name="username"
        id="username"
        type="text"
        outlined
        required
      />

      <v-row no-gutters>
        <v-col>
          <v-btn
            @click="$router.push('/login')"
            :disabled="isLoading"
            color="primary"
            depressed
            large
            text
          >
            <span class="d-flex align-center text-body-1 font-weight-medium">
              <v-icon left>mdi-chevron-left</v-icon>
              {{ $t('auth.back') }}
            </span>
          </v-btn>
        </v-col>
        <v-col>
          <div class="text-right">
            <v-btn
              :loading="isLoading"
              color="primary"
              type="submit"
              depressed
              large
            >
              <span class="text-body-1 font-weight-medium">
                {{ $t('auth.send') }}
              </span>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { api } from '../../services'
import { email } from '@/util/errorHandling'
import { mapActions } from 'vuex'

import HSuccess from '../../components/app/HSuccess'

export default {
  name: 'RecoverPasswordForm',

  components: {
    HSuccess,
  },

  methods: {
    ...mapActions(['showErrorMessage']),

    async validate() {
      if (!this.$refs.form.validate()) return

      this.isLoading = true

      await api.post('/web/open/user/sendResetPasswordEmail', { username: this.username })
        .then(() => this.showSuccessMessage = true)
        .catch(({ data }) => this.showErrorMessage(data.message))
        .finally(() => this.isLoading = false)
    }
  },

  data() {
    return {
      isLoading: false,
      showSuccessMessage: false,

      username: '',

      rules: {
        email,
      },
    }
  }
}
</script>
